var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.selectedDeparting)?_c('span',{staticClass:"marker"},[_vm._v(" Departing ")]):_vm._e(),(_vm.selectedReturning)?_c('span',{staticClass:"marker"},[_vm._v(" Returning ")]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }